import styles from '../../../sass/apricot.module.scss';
export default (function (_ref) {
  var message = _ref.message,
      title = _ref.title,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$useWrapper = _ref.useWrapper,
      useWrapper = _ref$useWrapper === void 0 ? false : _ref$useWrapper;
  var error = title ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " alert alert-danger cb-alert-heading"),
    role: "alert",
    tabIndex: "0"
  }, title ? /*#__PURE__*/React.createElement("h2", null, title) : null, message ? /*#__PURE__*/React.createElement("p", null, message) : null) : /*#__PURE__*/React.createElement("p", {
    className: "".concat(className, " alert alert-danger")
  }, message);
  return useWrapper ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles['err-wrapper'], " container")
  }, error) : error;
});